export default __webpack_public_path__ + "static/media/mobileMenu.134ea3fe.gif";